<template>
  <skeleton-loader v-if="loading" width="100%" animation="fade"/>
  <v-layout class="nx-dashboard-card ma-0 pa-3" v-else white row wrap column>
    <v-toolbar class="nx-filters-toolbar nx-heading--level-1 pb-3 ma-0"
               color="transparent"
               height="40px"
               flat>
      <v-toolbar-title class="title"><slot name="header">{{ title }}</slot></v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="prepend-action"></slot>
      <slot name="action" v-if="!hideActions" class="ml-auto">
        <nx-show-more><slot name="content"></slot></nx-show-more>
      </slot>
    </v-toolbar>
    <slot name="body"></slot>
    <slot name="footer"></slot>
  </v-layout>
</template>

<script>
import SkeletonLoader from '@/components/skeleton/SkeletonLoader';
import NxShowMore from '@/components/menu/ShowMore';

export default {
  name: 'nx-dashboard-card',
  components: {
    NxShowMore,
    SkeletonLoader,
  },
  props: {
    title: {
      type: String,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>

<style lang="stylus">
  .nx-dashboard-card {
    .v-toolbar__content {
      padding: 0;
      margin-right: -16px;
    }
  }
</style>
